const { OC } = window;

export default OC;
